import fetch from "./fetch";
/**
 * 医院管理
 */
const hospital = {
  //分页查询
  selectHospitalList(params) {
    return fetch({
      isLoading: true,
      url: "/hospital/page",
      method: "GET",
      params,
    });
  },
  // 医院删除
  deleteHospital(id) {
    return fetch({
      url: "/hospital/delete",
      method: "POST",
      params: {id},
    })
  }
};

export default hospital;
